import Vue from 'vue'
import GlobalFooter from './App.vue'

import './main.entry.scss'

const init = () => {
  const mountEl = document.querySelector('#globalFooterApp')
  if (!mountEl) {
    return false
  }
  new Vue({render: h => h(GlobalFooter)
  }).$mount(mountEl)
}
init()
